<template>
  <div>
    <!-- 골프 Summary WEB -->
    <div class="web">
      <div class="outterBox">
        <div class="topHeader">
          <span class="headerText">접수정보 확인</span>
        </div>
        <div class="headerTitle">
          <div style="margin-top: 0.5rem; padding-left: 2rem" class="headerDetailText">
            ※ 접수 정보 확인 후, 하단의 "완료" 버튼을 누르시면 접수가 완료됩니다. (마이페이지 > 예약정보관리 >
            {{ getListType }}에서 내역 확인 가능)
          </div>
        </div>
        <div class="top">
          <div class="itemContainer">
            <div class="table-responsive bg-white text-center">
              <b-table class="tableStyle" striped hover fixed :items="summaryList" :fields="fields">
                <template #cell(show_details)="row">
                  <button class="detailButton" size="sm" @click="row.toggleDetails">
                    <span>{{ row.detailsShowing ? '-' : '+' }}</span>
                  </button>
                </template>

                <template #cell(delete)="data">
                  <div class="text-center">
                    <button class="deleteButton" size="sm" @click="deleteReceipt(data.index)">
                      <span>삭제</span>
                    </button>
                  </div>
                </template>

                <template #row-details="data">
                  <ReceiptSummaryDetail :list-type="listType" :revConfirm="data.item.data" />
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 골프 Summary MOBILE -->

    <div class="mobile">
      <div class="outterBox">
        <div class="topHeader">
          <span class="headerText">접수정보 확인</span>
        </div>
        <div class="headerTitle">
          <div style="margin-top: 0.5rem; padding-left: 1rem" class="headerDetailText">
            ※ 접수 정보 확인 후, 하단의 "완료" 버튼을 누르시면 접수가 완료됩니다. (마이페이지 > 예약정보관리 >
            사전접수에서 내역 확인 가능)
          </div>
        </div>
        <div class="top">
          <div class="itemContainer">
            <p class="mb-3 countText">
              총 <span class="numText"> {{ summaryList.length }} </span> 건
            </p>
            <div v-show="summaryList.length > 0">
              <div class="item" v-for="(item, index) in summaryList" :key="index">
                <div class="col mobileList">
                  <div class="row justify-content-center">
                    <div class="col-3 d-flex justify-content-left text-left text-nowrap">이용일자</div>
                    <div class="col-6">{{ item.bookDate }}</div>
                    <div class="col-3 d-flex justify-content-end">
                      <button class="deleteButton" size="sm" @click="deleteReceipt(index)">
                        <span>삭제</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <hr class="col" />
                  </div>
                  <div class="rowSpace"></div>
                  <div class="row">
                    <div class="col-3 d-flex justify-content-left text-left text-nowrap">이용자</div>
                    <div class="col-9">{{ item.gscName }}</div>
                  </div>
                  <div class="rowSpace"></div>
                  <div class="row">
                    <div class="col-3 d-flex justify-content-left text-left text-nowrap">티오프</div>
                    <div class="col-9">{{ item.timeDetailText }}</div>
                  </div>
                  <div class="rowSpace"></div>
                  <div class="row">
                    <div class="col-3 d-flex justify-content-left text-left text-nowrap">접수일자</div>
                    <div class="col-9">{{ item.regDate }}</div>
                  </div>
                  <div class="rowSpace"></div>
                  <div class="row">
                    <hr class="col" />
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-12" @click="headerClicked(index)">
                      <div class="d-flex justify-content-between">
                        <b>상세보기</b>
                        <b-icon
                          icon="chevron-up"
                          class="align-self-center"
                          font-scale="1"
                          v-show="selectedItemIndex === index"
                        />
                        <b-icon
                          icon="chevron-down"
                          class="align-self-center"
                          font-scale="1"
                          v-show="selectedItemIndex !== index"
                        />
                      </div>
                      <!--                      <template #cell(show_details)="row">-->
                      <!--                        <button class="detailButton" size="sm" @click="row.toggleDetails">-->
                      <!--                          <span>{{ row.detailsShowing ? '-' : '+' }}</span>-->
                      <!--                        </button>-->
                      <!--                      </template>-->
                      <!--                      <template #row-details="data">-->
                      <!--                        <ReceiptSummaryDetail :list-type="listType" :table-data="data" />-->
                      <!--                      </template>-->

                      <!--                <template #cell(show_details)="row">-->
                      <!--                  <button class="detailButton" size="sm" @click="row.toggleDetails">-->
                      <!--                    <span>{{ row.detailsShowing ? '-' : '+' }}</span>-->
                      <!--                  </button>-->
                      <!--                </template>-->
                    </div>
                  </div>
                  <TransitionCollapseHeight v-show="selectedItemIndex === index">
                    <ReceiptSummaryDetail :list-type="listType" :revConfirm="item.data" />
                  </TransitionCollapseHeight>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="mobile">-->
    <!--      <div class="outterBox">-->
    <!--        <div class="topHeader">-->
    <!--          <span class="headerText">접수정보 확인</span>-->
    <!--        </div>-->
    <!--        <div class="top">-->
    <!--          <div class="table-responsive bg-white text-center">-->
    <!--            <b-table class="tableStyle" striped hover fixed :items="summaryList" :fields="fields">-->
    <!--              <template #cell(show_details)="row">-->
    <!--                <button class="detailButton" size="sm" @click="row.toggleDetails">-->
    <!--                  <span>{{ row.detailsShowing ? '-' : '+' }}</span>-->
    <!--                </button>-->
    <!--              </template>-->

    <!--              <template #cell(delete)="data">-->
    <!--                <div class="text-center">-->
    <!--                  <button class="deleteButton" size="sm" @click="deleteReceipt(data.index)">-->
    <!--                    <span>삭제</span>-->
    <!--                  </button>-->
    <!--                </div>-->
    <!--              </template>-->

    <!--              <template #row-details="data">-->
    <!--                -->
    <!--                <ReceiptSummaryDetail :list-type="listType" :table-data="data" />-->
    <!--              </template>-->
    <!--            </b-table>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {PMSReqGolfReceiptNew} from '@/models-golf';
import moment from 'moment';
import ReceiptSummaryDetail from '@/pages/RevReceiptPage/Component/ReceiptSummaryDetail';
import TransitionCollapseHeight from '@/components/TransitionCollapseHeight';
import {DateUtil} from '@/util/DateUtil';
import {getReservText} from '@/util/GolfUtil';

export default {
  name: 'ReceiptSummary',
  components: {ReceiptSummaryDetail, TransitionCollapseHeight},
  props: {
    listType: String,
    revConfirmList: Array,
  },

  data() {
    return {
      fields: [],
      summaryList: [],
      selectedItemIndex: -1,
    };
  },
  computed: {
    getListType() {
      return getReservText(this.listType);
    },
  },

  created() {
    this.genReceiptFields();
    this.genSummaryData();
    console.log(this.revConfirmList);
    console.log(this.fields);
    console.log(this.summaryList);
  },

  methods: {
    genReceiptFields() {
      this.fields = [
        {
          key: 'bookDate',
          label: '이용일자',
        },
        {
          key: 'gscName',
          label: '이용자',
        },
        {
          key: 'timeDetailText',
          label: '티오프',
        },
        {
          key: 'regDate',
          label: '접수일자',
        },
        {
          key: 'show_details',
          label: '상세보기',
        },
        {
          key: 'delete',
          label: '삭제',
        },
      ];
    },
    genSummaryData() {
      this.summaryList = [];
      this.revConfirmList.forEach(x => {
        let data = {
          data: x,
          regDate: DateUtil.getYYYY_MM_DD_WEEK(Date.now()),
          gscName: x.receiptDetail.gscName,
          bookDate: DateUtil.getYYYY_MM_DD_WEEK(x.selectedDate),
          holeCd: 18,
          timeDetailText:
            this.listType === 'REAL' ? this.toTime(x.selectedRealTeeOff.time) : x.selectedTeeOff.detailName,
        };
        this.summaryList.push(data);
      });
    },
    deleteReceipt(index) {
      console.log('delete', index, this.revConfirmList);

      this.$bvModal
        .msgBoxConfirm('삭제 시 기존 입력한 정보는 사라집니다.', {
          title: '삭제 확인',
          okTitle: '확인',
          cancelTitle: '취소',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.revConfirmList.splice(index, 1);
            this.summaryList.splice(index, 1);
            if (this.revConfirmList.length === 0) {
              // this.stage = 1;
              this.$EventBus.$emit('GoFirstStage');
            }
          }
        });
    },

    toTime(a) {
      if (!a) return '';
      let position = 2;
      var output = [a.slice(0, position), ':', a.slice(position)].join('');
      return output;
    },
    headerClicked(i) {
      if (this.selectedItemIndex === i) {
        this.selectedItemIndex = -1;
      } else {
        this.selectedItemIndex = i;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.outterBox {
}

.topHeader {
  padding-top: 2rem;
  padding-left: 2rem;
  font-weight: bold;
  font-size: 1.3rem;
}

.top {
  display: flex;
  padding: 1rem;
}
.deleteButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 50%;
  background-color: transparent !important;
  padding: 0px !important;
  color: #c6462f;
  border: none;
  outline: none;
  text-align: center;

  span {
    padding: 0px;
    width: 100%;
    text-align: center;
    padding: 0px !important;
  }
}
.detailButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 50%;
  background-color: #af8c5e !important;
  padding: 0px !important;
  color: white;
  border: none;
  outline: none;

  span {
    padding: 0px;
    width: 100%;
    text-align: center;
    padding: 0px !important;
  }
}
.web {
  display: block;
}
.mobile {
  display: none;
}
.itemContainer {
  width: 100%;
  margin: 0 auto;
  .item {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;

    .itemHeader {
      display: flex;
      /*background-color: red;*/
      line-height: 2.5rem;
      background-color: white;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border: 1px solid #cccccc;

      &:hover {
        border: 1px solid #af8c5e;
        cursor: pointer;
      }
      .info {
        display: inline-block;
        text-align: center;
        line-height: 2.5rem;
        margin-left: 2%;
        margin-right: 2%;
        flex: 1;
        .infoTitle {
          font-weight: bold;
          border-bottom: 1px solid #eeeeee;
        }
        .infoData {
          font-size: 1rem;
        }
      }

      .arrow {
        display: block;
        text-align: right;
        vertical-align: middle;
        line-height: 400%;
        font-size: 1.2rem;
        padding-right: 1rem;
        .b-icon {
          vertical-align: middle;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .web {
    display: none;
  }
  .mobile {
    display: block;
    .col {
      font-size: 0.9rem;
    }
    .row {
      font-size: 0.9rem;
    }
    p {
      span {
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }
  .topHeader {
    width: 100%;
    margin: 0 auto;
    padding-top: 1rem;
    padding-left: 1rem;
    font-weight: bold;
    font-size: 1.3rem;
    .headerDetailText {
      padding-left: 1rem;
      font-size: 0.8rem;
      color: #999999;
      margin-left: 2rem;
      width: 100%;
    }
  }

  .top {
    display: flex;
    padding: 1rem;
    font-size: 0.8rem;
  }
  .deleteButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    background-color: transparent !important;
    padding: 0px !important;
    color: #b44646;
    border: none;
    outline: none;

    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
  }
  .detailButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 50%;
    background-color: #3f8397 !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;

    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      background-color: #346d7d !important;
      color: white;
    }
  }

  ::v-deep .table td {
    padding: 0.1rem !important;
  }

  .tableStyle {
    white-space: pre-line;
  }
  .mobileList {
    font-size: 0.8rem;
    border: 1px solid #e3e3e3;
    margin-top: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    //padding-bottom: 0.5rem;
    .row {
      line-height: 2rem;
      .col-3 {
        font-weight: 600;
        line-height: 2.3rem;
      }
      .col-6 {
        line-height: 2.3rem;
      }
      .col-9 {
        line-height: 2.3rem;
      }
      .col {
        p {
          line-height: 2.3rem;
        }
      }
    }
    hr {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }
  .itemContainer {
    font-size: 0.8rem;
    p {
      font-size: 1rem;
      .countText {
      }
    }
    .numText {
      font-size: 1.1rem;
    }
    .item {
      margin-top: 0rem;
      margin-bottom: 0rem;

      .itemHeader {
        display: block;
        text-align: center;
        /*background-color: red;*/
        line-height: 2.5rem;
        background-color: white;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border: 1px solid #cccccc;
        .row {
          width: 100%;
          margin-left: auto;
          margin-right: auto;
        }
        .col-2 {
          padding: 0px;
        }
        .col-4 {
          padding: 0px;
        }
        &:hover {
          border: 1px solid #af8c5e;
          cursor: pointer;
        }
        .info {
          display: inline-block;
          text-align: center;
          line-height: 2.5rem;
          margin-left: 2%;
          margin-right: 2%;
          flex: 1;
          .infoTitle {
            font-weight: bold;
            border-bottom: 1px solid #eeeeee;
          }
          .infoData {
            font-size: 0.8rem;
          }
        }

        .arrow {
          display: none;
        }
      }
    }
  }
}
</style>
